export default __webpack_public_path__ + "static/media/custom_software.edd8baa4.png";